module.exports = __webpack_public_path__ + "img/dpsy-icon-rc.7a12d8b5.png";